import { LAST_5_YEARS } from '@modules/common/constants';
import { FeedbackListDrawer } from '@modules/feedback/components/FeedbackListDrawer';
import { IntegrationSource } from '@modules/integrationsV2/types';
import { trackIntegrationPageEvent } from '@modules/integrationsV2/utils';
import { ChatRounded } from '@mui/icons-material';
import {
  Box,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Typography,
} from '@mui/material';
import { TimeUnit } from 'generated/graphql';
import { useMemo, useState } from 'react';
import { TimeRange } from 'v2/core/entities';
import { SourceName } from 'v2/core/entities/fields';

interface PreviewFeedbackCardActionProps {
  sourceDisplayName: string;
  integrationSource: IntegrationSource;
  isDisabled?: boolean;
}

export const PreviewFeedbackCardAction = ({
  integrationSource,
  sourceDisplayName,
  isDisabled,
}: PreviewFeedbackCardActionProps) => {
  const [isFeedbackDrawerOpen, setIsFeedbackDrawerOpen] = useState(false);

  const { source: eqlSource } = integrationSource;

  const queryContainer = useMemo(
    () => ({
      DateRange: LAST_5_YEARS as TimeRange,
      WhereClause: {
        filter: {
          sourceFilter: {
            sources: [{ name: eqlSource as SourceName }],
          },
        },
      },
      AggregatePeriod: TimeUnit.Month,
    }),
    [eqlSource],
  );

  if (!eqlSource) {
    return null;
  }

  const handleClick = () => {
    setIsFeedbackDrawerOpen(true);
    trackIntegrationPageEvent({
      eventName:
        'Integrations - Preview Feedback Card Button From Toolbar Clicked',
      integration: {
        integrationType: integrationSource.integrationType,
        channelType: integrationSource.channel.type,
        namespace: integrationSource.namespace,
      },
    });
  };

  return (
    <>
      {queryContainer && (
        <FeedbackListDrawer
          open={isFeedbackDrawerOpen}
          onClose={() => setIsFeedbackDrawerOpen(false)}
          queryContainer={queryContainer}
          header={{
            shouldEnableSort: true,
            renderTitle: () => (
              <Typography variant="subtitle2">Feedback for</Typography>
            ),
            renderDescription: () => (
              <Typography variant="subtitle1">
                <Box component="span" color="text.secondary">
                  Source:
                </Box>{' '}
                {sourceDisplayName}
              </Typography>
            ),
          }}
        />
      )}
      <MenuItem onClick={handleClick} disabled={isDisabled}>
        <ListItemIcon>
          <ChatRounded fontSize="small" />
        </ListItemIcon>
        <ListItemText>Preview Feedback Card</ListItemText>
      </MenuItem>
    </>
  );
};
